// Single source of truth for the portal version shown in the UI (Sidebar foot).
//
// CONVENTION: bump the patch on EVERY platform change (portal OR engine), then
// redeploy the portal so the live version reflects the latest deploy. Format is
// <major>.<minor>.<patch>-poc. Keep package.json "version" in sync.
export const APP_VERSION = '0.2.56-poc'
